import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import BuyerOnlyRouteMixin from 'sh-www/mixins/buyer-only-route-mixin';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { POSTING_CREATE__QUERY_PARAMS } from 'sh-www/constants/routes/posting-create';

class PostingCreateRoute extends Route.extend(BuyerOnlyRouteMixin) {
  /**
   * Register services
   */
  @service router;
  @service('states/routes/posting-create') state;
  @service('state-managers/routes/posting-create') stateManager;

  /**
   * @inheritDoc
   */
  activate() {
    super.activate(...arguments);

    this.stateManager.toggleConfirmDiscardData(true);
    this.state.initializeForcedProperties();
  }

  /**
   * @inheritDoc
   */
   beforeModel() {
    // WARNING - DO NOT follow this pattern.
    // stateManager.initStateManager and state.initializePropertyDefaults should be called in `model`
    this.stateManager.initStateManager();
   }

  /**
   * @inheritDoc
   */
  afterModel() {
    this.stateManager.registerOnDraftSuccessNavigation((assignment) => {
      this.router.transitionTo(EMBER_ROUTE_NAMES.POSTING__PENDING, assignment.idWithSlug);
    });
  }

  /**
   * @inheritDoc
   */
  setupController() {
    super.setupController(...arguments);

    const applicationController = this.controllerFor('application');
    applicationController.set('isShowCreatePostingHeader', true);
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.setProperties({
        [POSTING_CREATE__QUERY_PARAMS.CLONE_ID]: null,
        [POSTING_CREATE__QUERY_PARAMS.SERVICE_IDS]: null,
        [POSTING_CREATE__QUERY_PARAMS.CLASSIFICATION_IDS]: null,
        [POSTING_CREATE__QUERY_PARAMS.LOCATION_ID]: null,
        [POSTING_CREATE__QUERY_PARAMS.MAX_RATE]: null,
        [POSTING_CREATE__QUERY_PARAMS.RATE_TYPE]: null,
      });
    }
  }

  /**
   * @inheritDoc
   */
  deactivate() {
    this._super(...arguments);

    const applicationController = this.controllerFor('application');
    applicationController.set('isShowCreatePostingHeader', false);

    this.stateManager.initStateManager();
    this.stateManager.toggleConfirmDiscardData(false);
  }
}

export default PostingCreateRoute;
